import React from 'react';
import PropTypes from 'prop-types';
import { CaptionText } from '@paypalcorp/pp-react';
import getLocaleMessages from '../../utils/localesMessages';

const { previewContainerText, browser } =
  getLocaleMessages('buttonsV3/preview');

const ImageButtonPreview = ({ buttonImageUrl, onError }) => {
  if (!buttonImageUrl) {
    return (
      <div
        className="button-preview-holder"
        data-testid="button-preview-holder"
      >
        <CaptionText>{previewContainerText}</CaptionText>
      </div>
    );
  }

  return (
    <div className="buttons">
      <img
        src={buttonImageUrl}
        alt={browser.header}
        onError={(error) => {
          if (onError) {
            onError(error);
          }
        }}
      />
    </div>
  );
};

ImageButtonPreview.propTypes = {
  buttonImageUrl: PropTypes.string,
  onError: PropTypes.func,
};

export default ImageButtonPreview;
